import { render, staticRenderFns } from "./ReportProjectCostVariancePage.vue?vue&type=template&id=678195a6&scoped=true&"
import script from "./ReportProjectCostVariancePage.vue?vue&type=script&lang=js&"
export * from "./ReportProjectCostVariancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678195a6",
  null
  
)

export default component.exports